import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import styled from "styled-components";

interface SearchProps {
  placeholder: string;
  setSearchValue: Dispatch<SetStateAction<string | undefined>>;
  isDisabled?: boolean;
  defaultValue?: string;
  pageResetEvent?: () => void;
  inputType?: string;
  isResetValue?: boolean;
}

interface SSearchInput {
  isDisabled?: boolean;
}

interface SSearchImg extends SSearchInput {
  isFocused: boolean;
}

export default function Search({
  placeholder,
  setSearchValue,
  isDisabled,
  defaultValue,
  pageResetEvent,
  inputType,
  isResetValue,
}: SearchProps) {
  const [isFocused, setIsFocused] = useState(false);
  const [value, setValue] = useState(defaultValue ?? "");

  useEffect(() => {
    if (defaultValue && defaultValue !== "") {
      setValue(defaultValue);
    } else if (defaultValue === undefined) {
      setValue("");
    }
  }, [defaultValue]);

  useEffect(() => {
    if (isResetValue) {
      setValue("");
    }
  }, [isResetValue, setSearchValue]);

  return (
    <SearchContainer>
      <SearchInput
        type={inputType ?? "text"}
        inputMode={inputType === "number" ? "numeric" : undefined}
        placeholder={placeholder}
        value={value}
        disabled={isDisabled}
        isDisabled={isDisabled}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            setSearchValue(value);

            if (pageResetEvent) {
              pageResetEvent();
            }
          }
        }}
      />

      <SearchImg
        isFocused={isFocused}
        isDisabled={isDisabled}
        onClick={() => {
          setSearchValue(value);

          if (pageResetEvent) {
            pageResetEvent();
          }
        }}
      >
        <span className="material-icons-outlined">search</span>
      </SearchImg>
    </SearchContainer>
  );
}

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchInput = styled.input<SSearchInput>`
  width: 240px;
  height: 38px;
  padding: 10px 40px 10px 16px;
  border: solid 1px ${({ theme }) => theme.buttonColor.lineNormal};
  border-radius: 3px;
  background-color: #ffffff;

  font-size: 14px;
  text-align: left;

  &::placeholder {
    font-size: 14px;
    text-align: left;
    color: #858c97;
  }

  &:focus {
    border: solid 1px #00c7c7;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: #f5f5f5;
    border-color: ${({ theme }) => theme.buttonColor.lineNormal};
  }
`;

export const SearchImg = styled.div<SSearchImg>`
  position: absolute;
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  width: 24px;
  height: 24px;
  right: 8px;

  span {
    color: ${({ isDisabled, isFocused }) =>
      isDisabled ? "#aaafb9" : isFocused ? "#00c7c7" : "#858c97"};
  }
`;
